import { useAppDispatch, useAppSelector } from "@/store";
import { setCollapsed, toggleCollapsed } from "@/store/slices/sidebar-slice";
import type { RootState } from "@/store/store";

export const useLayoutSidebar = () => {
    const isCollapsed = useAppSelector((state: RootState) => state.layoutSidebar.isCollapsed);
    const dispatch = useAppDispatch();

    const collapse = () => dispatch(setCollapsed(true));
    const expand = () => dispatch(setCollapsed(false));
    const toggle = () => dispatch(toggleCollapsed());

    return { isCollapsed, collapse, expand, toggle };
};
